/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-16 10:29:39
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-24 17:16:15
 */
const servicePackage = [
    {
      path: '/service/detail/:id/:tenantId',
      name: 'servicePackageDetail',
      component: () => import('../views/servicePackage/detail.vue'),
    },
    {
        path: '/service/saver/order/:id',
        name: 'servicePackagesaverOrder',
        component: () => import('../views/servicePackage/saveOrder.vue'),
        meta:{
          keepAlive:true
        }
    },
    {
        path: '/service/goods/detail/:id',
        name: 'servicePackageOrderDetail',
        component: () => import('../views/servicePackage/serviceDetail.vue'),
    },
    {
        path: '/servicePackage/insuranceItems/group-notice',
        name: 'groupNotice',
        component: () => import('../views/servicePackage/insuranceItems/group-notice'),
        // meta:{
        //   keepAlive:true
        // }
    },
    {
      path: '/servicePackage/insuranceItems/sign',
      name: 'groupNotice',
      component: () => import('../views/servicePackage/insuranceItems/sign'),
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/servicePackage/insuranceItems/group-info',
      name: 'groupInfo',
      component: () => import('../views/servicePackage/insuranceItems/group-info'),
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/servicePackage/deviceItems/view-device/:id',
      name: 'viewDevice',
      component: () => import('../views/servicePackage/deviceItems/view-device'),
    },
    {
      path: '/servicePackage/deviceItems/confirm-device/:id',
      name: 'confirmDevice',
      component: () => import('../views/servicePackage/deviceItems/confirm-device'),
    },
    {
      path: '/servicePackage/deviceItems/apply-device/:id',
      name: 'applyDevice',
      component: () => import('../views/servicePackage/deviceItems/apply-device'),
    },
    {
      path: '/servicePackage/deviceItems/apply-device-success/:id',
      name: 'applyDeviceSuccess',
      component: () => import('../views/servicePackage/deviceItems/apply-device-success'),
    },
  ]
  export default servicePackage


// WEBPACK FOOTER //
// ./src/router/servicePackage.js